import React from 'react';
import './today-home-overview.css';

export default function TodayOverview({summary,collections}) {
 return <div className="today-home-overview">
  <div className="today-dashboard__grid">
   {summary}
   {collections}
  </div>
 </div>;
}
